import { combineReducers } from "redux";
import devideReducer from './devideReducer';
import authReducer from './authReducer';

const rootReducer = combineReducers({
    devide: devideReducer,
    auth: authReducer,
});

export default rootReducer;